import styled, { css } from "styled-components";
import { Colors } from "../../config";
import { Wrapper, Error } from "../../config/StyledComponents";

const InputField = ({
  type,
  label,
  required,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
  disabled,
  onChange,
  placeholder,
  value,
  name,
  maxLength,
  helperText,
  isRounded,
  width,
  leftImg,
  onFocus,
  onBlur,
  onKeyDown
}) => {
  return (
    <Wrapper>
     <Label>
        {label} {required && <Required>*</Required>}
      </Label>
      <LeftImg src={leftImg} helperText={helperText} />
      <TextField
        type={type || "text"}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        name={name}
        autoComplete="off"
        maxLength={maxLength}
        helperText={helperText}
        isRounded={isRounded}
        width={width}
        leftImg={leftImg}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      {helperText && <Error isRounded={isRounded}>{helperText}</Error>}
    </Wrapper>
  );
};

const LeftImg = styled.img`
  width: 1.5rem;
  position: absolute;
  bottom: 0.75rem;
  left: 1rem;
  ${(props) =>
    props.helperText &&
    css`
      bottom: 2rem;
    `}
`;
const TextField = styled.input`
  font-style: normal;
  background-color: ${(props) => (props.disabled ? "#f0f0f0" : "white")};
  color: ${(props) =>
    props.value && props.disabled
      ? Colors.sharkOpacity30
      : props.disabled
      ? Colors.sharkOpacity10
      : Colors.shark};
  cursor: ${(props) => (props.disabled ? "no-drop" : "default")};
  font-size: 0.9rem;
  font-weight: 400;
  padding: ${(props) => (props.isRounded ? "0.9rem 1.25rem" : "0.844rem 0.75rem")};
  padding-left: ${(props) =>
    props.leftImg ? "3rem" : props.isRounded ? "1.5rem" : "0.75rem"};
  border-radius: ${(props) => (props.isRounded ? "2.5rem" : "0.625rem")};
  border: ${(props) =>
    props.helperText
      ? `1px solid ${Colors.red}`
      : props.isRounded
      ? `1px solid ${Colors.coolGrey}`
      : "none"};
  ::placeholder {
    color: ${(props) =>
      props.isRounded ? Colors.sharkOpacity20 : Colors.sharkOpacity30};
    font-weight: 400;
  }
`;

const Label = styled.div`
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const Required = styled.span`
  color: red;
`;

export default InputField;
